import { render } from "./hostTopicInfo.vue?vue&type=template&id=b546a2c0&scoped=true"
import script from "./hostTopicInfo.vue?vue&type=script&lang=js"
export * from "./hostTopicInfo.vue?vue&type=script&lang=js"

import "./hostTopicInfo.vue?vue&type=style&index=0&id=b546a2c0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b546a2c0"]])

export default __exports__